<template lang="pug">
  div.col(ref='root', :title="title" @contextmenu='openMenu')
    div(ref="placeholder")
    template(v-if="ready")
      pre.pre(v-if="mode=='body' && (!isSpecialType || (isSpecialType && !editable)) "
      v-show="!editable || !editing"
      :style="{backgroundColor: nowColor}"
      :title="title"
      ) {{processedContent}}
      div.input(
        v-if="mode=='form' || editing || (isSpecialType && editable)",
        style="text-align:center;width:100%",
        )
        input.s(v-if="inputType=='text'" type="text",
          ref='input'
          v-model="content"
        )

        span(v-if="inputType=='file'")
          popover.a(v-if="content && content instanceof Array && content.length > 0")
            span(slot="trigger") 查看({{content.length}})
            // div 点击文件名下载：
            div(v-for="(t, k) in content" style="border-bottom:1px solid #ccc")
              div {{t}}
              a.a(@click="colOpts.previewHandler(t)")
                | 预览
              span &nbsp;
              a.a(v-if="userInservice" @click="colOpts.downloadHandler(t)")
                | 下载
            div(style="text-align:right")
              a.a(@click="colOpts.uploadHandler(rowObj)")
                | 继续上传
          a.a(v-else @click="colOpts.uploadHandler(rowObj)")
            | 上传
        span(v-if="inputType=='cv' || inputType=='原始简历'")
          popover.a(v-if="content && content instanceof Array && content.length > 0")
            span(slot="trigger") 查看({{content.length}})
            // div 点击文件名下载：
            div(style="font-weight:bold;") 简历
            div(v-for="(t, k) in content" style="border-bottom:1px solid #ccc")
              div {{t}}
              a.a(@click="colOpts.previewHandler({t:t, k:k, obj:rowObj, label:'简历'})")
                | 预览
              span &nbsp;
              a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:t, k:k, obj:rowObj, label:'简历'})")
                | 下载
              span &nbsp;
              a.a(@click="colOpts.genHandler({t:t, k:k, obj:rowObj})")
                | 生成
              span &nbsp;
              a.a(@click="colOpts.deleteHandler({label:'简历', key:k, obj:rowObj})")
                | 删除
            div(style="text-align:right")
              a.a(@click="colOpts.uploadHandler({label:'简历', item: rowObj})")
                | 继续上传
            div(style="border-bottom:2px solic #ccc") &nbsp;
            div(style="font-weight:bold;") 推荐报告
            div(v-for="(t, k) in rowObj['推荐报告']" style="border-bottom:1px solid #ccc")
              a.a(@click="colOpts.editHandler({t:t, k:k, obj:rowObj})") {{t}}
              br
              //div(v-if="opts.sTag=='0'")
              div
                a.a(@click="colOpts.previewHandler({t:t, k:k, obj:rowObj, label:'推荐报告'})")
                  | 预览
                span &nbsp;
                a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:t, k:k, obj:rowObj, label:'推荐报告'})")
                  | 下载
                span &nbsp;
                a.a(@click="colOpts.manuHandler(rowObj)")
                  | 制作
                span &nbsp;
                a.a(@click="colOpts.deleteHandler({label:'推荐报告', key:k, obj:rowObj})")
                  | 删除
            div(style="border-bottom:2px solic #ccc") &nbsp;
            div(style="font-weight:bold;") 本地推荐报告
            div(v-if="rowObj['本地推荐报告'] && rowObj['本地推荐报告'] instanceof Array && rowObj['本地推荐报告'].length > 0")
              div(v-for="(t, k) in rowObj['本地推荐报告']" style="border-bottom:1px solid #ccc")
                div {{t}}
                a.a(@click="colOpts.previewHandler({t:t, k:k, obj:rowObj, label:'本地推荐报告'})")
                  | 预览
                span &nbsp;
                a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:t, k:k, obj:rowObj, label:'本地推荐报告'})")
                  | 下载
                span &nbsp;
                a.a(@click="colOpts.deleteHandler({label:'本地推荐报告', key:k, obj:rowObj})")
                  | 删除
              div(style="text-align:right")
                a.a(@click="colOpts.uploadHandler({label:'本地推荐报告', item: rowObj})")
                  | 继续上传
            a.a(v-else @click="colOpts.uploadHandler({label:'本地推荐报告', item: rowObj})")
              | 上传
          a.a(v-else @click="colOpts.uploadHandler({label:'简历', item: rowObj})")
            | 上传
        span(v-if="inputType=='download'")
          popover.a(v-if="content && typeof content == 'object'")
            span(slot="trigger") 查看({{content.length}})
              // div 点击文件名下载：
            div(v-for="(t, k) in content")
              div {{t}}
              a.a(@click="colOpts.previewHandler({t:t, k:k, obj:rowObj})")
                | 预览
              span &nbsp;
              a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:t, k:k, obj:rowObj})")
                | 下载

          popover.a(v-else-if="content && typeof content == 'string'")
            span(slot="trigger") {{content}}
            div
              a.a(@click="colOpts.previewHandler({t:content, obj:rowObj})")
                | 预览
            div
              a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:content, obj:rowObj})")
                | 下载
            div
              a.a(v-if="colOpts.toWXHandler" @click="colOpts.toWXHandler({t:content, obj:rowObj})")
                | 发送到微信
            div
              a.a(v-if="colOpts.analyzeHandler", @click="colOpts.analyzeHandler({t:content, obj:rowObj})")
                | 解析入库

        span(v-if="inputType=='list'")
          popover.a(v-if="content && typeof content == 'string'")
            span(slot="trigger") {{ content }}
            div
              a.a(v-if="rowObj['类型']==='list' && content.toLowerCase().match(/\.(xlsx|xls)$/)" @click="colOpts.confuseHandler({t:content, obj:rowObj})")
                | 混淆并推送
              br
              a.a(v-if="rowObj['类型']==='list' && content.toLowerCase().match(/\.(xlsx|xls)$/)" @click="colOpts.admDownloadHandler({t:content, obj:rowObj})")
                | 下载并制作
              br
              a.a(v-if="rowObj['类型']==='list' && content.toLowerCase().match(/\.(xlsx|xls)$/)" @click="colOpts.admUploadHandler({t:content, obj:rowObj})")
                | 上传制作好的对应SL
              br
              a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:content, obj:rowObj})")
                | 下载
              br
              a.a(v-if="rowObj['类型'] !== 'list'" @click="colOpts.previewHandler({t:content, obj:rowObj})")
                | 预览
        span(v-else-if="inputType=='button'")
          el-button(type="primiry", size="mini", @click="colOpts.handler(rowObj)")
            span(v-if='colOpts.text') {{colOpts.text}}
            span(v-else) {{content}}
        span(v-else-if="inputType=='link'")
          a.a(@click="colOpts.handler(rowObj)")
            span(v-if='colOpts.text') {{colOpts.text}}
            span(v-else) {{content}}

        span(v-else-if="inputType=='checklist'")
          a.a(@click="colOpts.handler(rowObj)")
            span(v-text="content || colOpts.text")

        span(v-else-if="inputType=='session'")
          a.a(@click="colOpts.handler(rowObj)")
            span(v-if="content") 修改
            span(v-else) 设置

        template(v-else-if="inputType=='textarea'")
          textarea.textarea.s(ref='input'
            v-model="content", style="height:150px", :readonly="!!colOpts.readonly")

          div.row.add-remark(v-if="colOpts.addInput")
            textarea.flex(ref="addInput" v-model="remark" @blur="addRemark")
            button(@click="addRemark") 添加

          div(v-if="colOpts.addUpload")
            popover.a(v-if="rowObj[colOpts.label+'文件']")
              span(slot="trigger") 查看附件
              pre(v-for="(t, k) in rowObj[colOpts.label+'文件']")
                div {{t}}
                a.a(@click="colOpts.previewHandler({t:t, k:k, obj:rowObj})")
                  | 预览
                span &nbsp;
                a.a(v-if="userInservice" @click="colOpts.downloadHandler({t:t, k:k, obj:rowObj})")
                  | 下载
              pre
                a.a(@click="colOpts.uploadHandler(rowObj)") 上传附件
            a.a(v-else @click="colOpts.uploadHandler(rowObj)") 上传附件

        el-date-picker(v-else-if="inputType=='date'"
          ref='input'
          v-model="content"
          type="date"
          @change='onChange'
          placeholder="选择日期"
        )
        el-date-picker(v-else-if="inputType=='month'"
          ref='input'
          v-model="content"
          type="month"
          @change='onChange'
          placeholder="选择年月"
        )

        el-date-picker(v-else-if="inputType=='datetime'"
          ref='input'
          v-model="content"
          type="datetime"
          @change='onChange'
          placeholder="选择"
        )

        select(v-else-if="inputType=='color' && colOpts.selectHandler"
          ref='input'
          v-model="content"
          :style="{backgroundColor: nowColor, border:'0px'}"
          @change="colOpts.selectHandler(rowObj, content)")
          option(label="--" value="")
          template(v-for="(v, k) in colOpts.options")
            option(:style="{backgroundColor: v}") {{k}}

        select(v-else-if="inputType=='color'"
          ref='input'
          v-model="content"
          :style="{backgroundColor: nowColor, border:'0px'}")
          option(label="--" value="")
          template(v-for="(v, k) in colOpts.options")
            option(:style="{backgroundColor: v}") {{k}}

        select(v-else-if="inputType=='select'"
          ref='input'
          v-model="content")
          option(label="--" value="")
          template(v-for="(v, k) in colOpts.options")
            option {{v}}

        input(v-else-if="inputType=='number'"
          type="number"
          min="0"
          ref='input'
          v-model="content")

        popover(v-else-if="inputType=='single'"
        @confirm="singleSelect"
        :showConfirm="true")
          span(slot='trigger')
            a(v-if='content') {{content}}
            a(v-else) &nbsp;
          el-radio-group(v-model="mult" ref="mult")
            div(v-for="(v, k) in colOpts.options")
              el-radio(:label="k")

        popover(v-else-if="inputType=='multiple'"
        @confirm="multipleSelect"
        :showConfirm="true")
          span(slot='trigger')
            a {{content||'--'}}
          el-checkbox-group(v-model="mult" ref="mult")
            div(v-for="(v, k) in colOpts.options")
              el-checkbox(:label="k")

        popover(v-else-if="inputType=='cascade'"
        @confirm="multipleSelect"
        :showConfirm="true")
          span(slot='trigger' @click="findChild()" style="display:inline-block;width:100%")
            a(v-if='content') {{content}}
            a(v-else) &nbsp;&nbsp;&nbsp;&nbsp;
          el-checkbox-group(v-if="colOpts.options && showCascade" v-model="mult" ref="mult")
            div(v-for="(v, k) in colOpts.options" :key="v")
              el-checkbox(:label="k")
          div(v-else) 无数据
        popover(v-else-if="inputType=='spreadsheet'" :text="content || '---'"
          ref="input"
          @confirm="confirm"
          @beforeShow="beforeShow"
          :width="320"
          :showConfirm="true")
          spreadsheet(ref='ss', :opts='ss_opts')
        popover(v-else-if="inputType=='label'" text="查看")
          div(v-if="content")
            el-tag(v-for="(l, k) in content" type="primary" :key="k") {{l}}

        el-autocomplete(
          style="width:170px"
          v-else-if="inputType=='autocomplete'"
          ref='input'
          v-model="content"
          @input="onChange"
          :fetch-suggestions="fetchSuggestions")

        popover(v-else-if="inputType=='password'")
          span(slot='trigger')
            a 设置密码
          input.setpass(ref='setpass' type="password" v-model="pass" placeholder="输入新密码")
          button(@click='colOpts.setPass(rowObj, pass)') 确定

        popover(v-else-if="inputType=='readonly'")
          span(slot='trigger')
            span(v-if='processedContent', style="cursor:pointer") {{processedContent}}
          span {{content}}


      div.linkto(v-if="colOpts.linktoHandler && content"
                  @click="colOpts.linktoHandler(content)"
                  :title="colOpts.linktoTitle")
        a
          i.el-icon-caret-right

    div(v-if="!fake" ref="fake" v-show='false')
      table-cell(ref="fakeComp" :mode="mode", :col="col", :row="row", :rowObj="rowObj",
                  :opts="opts", :shownColumns="shownColumns", :fake='true')

</template>

<script>
// Generated by CoffeeScript 2.3.0
import Vue from 'vue'
import tableCell from './cell'

let dateFormat
let m
let special
let specialTypes
let suggestions

const indexOf = [].indexOf

dateFormat = require('dateformat')

special = [
  'input',
  'file',
  'cv',
  'download',
  'list',
  'link',
  'button',
  'checklist',
  'session',
  'password',
  'spreadsheet',
  'multiple',
  'cascade',
  'readonly',
  'label',
]

specialTypes = {}

special.map(s => (specialTypes[s] = true))

suggestions = {}

export default (m = {
  name: 'tableCell',
  props: {
    // value: [String, Array, Number]
    // type: String # text, password, select, checkbox, etc
    mode: String,
    col: Number,
    row: Number,
    rowObj: Object,
    opts: Object,
    shownColumns: Array,
    fake: Boolean,
    placeholder: NodeList,
  },
  data: function() {
    let data
    return (data = {
      content: '',
      editing: false,
      pass: '',
      mult: [],
      showCascade: false,
      processedContent: '',
      colOpts: {},
      isSpecialType: false,
      nowColor: '',
      inputType: 'text',
      editable: true,
      remark: '',
      title: '',
      ready: false,
      label: '',
      // 是否在职，在职true
      userInservice: true,
    })
  },
  // computed:
  //   title: ->
  //     console.log colOpts.hideTitle, @processedContent
  //     if colOpts.hideTitle then '' else @processedContent
  methods: {
    encode: function(text) {
      if (text == null) {
        text = ''
      }
      if (this.mode !== 'form') {
        text = text.replace(/\n/g, ' ')
      }
      return text
    },
    emitChange: function() {
      return this.$emit('change', this.content, this)
    },
    setOnblurEvent: function() {
      let input
      input = this.$refs.input
      if (!input) {
        // 对于spreadsheet等单元没有input
        return
      }
      input.onchange = input.onkeyup = e => {
        this.content = input.value
        return this.onChange()
      }
      input.onblur = e => {
        this.content = input.value
        return this.onChange()
      }
      // @cellblur()
      return this.$refs.input
    },
    onChange: function() {
      this.update(this.content)
      return this.emitChange()
    },
    edit: function() {
      // app.api.findOne
      //   tableName: @opts.tableName
      //   _id: @rowObj._id
      //   fields:
      //     "#{@label}": 1
      //     "html.#{@label}": 1
      // .then (v) =>
      //   @contentSaved = @content = @rowObj[@label] = v[@label] || ""
      //   @rowObj.html[@label] = v.html[@label]
      if (this.colOpts.beforeEdit && !this.colOpts.beforeEdit()) {
        return false
      }
      this.emitChange()
      if (this.editable && this.colOpts.editable !== false) {
        // && !@colOpts.display
        // load content from db
        this.editing = true
        return this.$nextTick(() => {
          let input
          this.setOnblurEvent()
          if (this.colOpts.addInput) {
            input = this.$refs.addInput
          } else {
            input = this.$refs.input
          }
          return input != null ? (typeof input.focus === 'function' ? input.focus() : void 0) : void 0
        })
      }
    },
    doHighlight: function() {
      if (this.mode === 'body') {
        // && @editable && !@editing
        this.$emit('highlight', this.row, this.col)
        return this.edit()
      }
    },
    fetchSuggestions: function(qs, cb) {
      let key, s
      key = `${this.colOpts.tableName}-${this.label}`
      s = []
      return Promise.resolve()
        .then(() => {
          if (suggestions[key]) {
            return (s = suggestions[key])
          } else if (this.colOpts.options) {
            return (s = suggestions[key] = this.colOpts.options.map(item => ({
              value: item,
            })))
          } else {
            return app.api
              .find({
                tableName: this.colOpts.tableName,
              })
              .then(
                list =>
                  (s = suggestions[key] = list.map(item => ({
                    value: item[this.colOpts.field],
                  }))),
              )
          }
        })
        .then(() => cb(s.filter(c => c.value && c.value.indexOf(qs) !== -1)))
    },
    confirm: function() {
      let items
      items = this.$refs.ss.getChecked()
      if (this.colOpts.handleConfirm) {
        this.colOpts.handleConfirm(items, this.rowObj)
      }
      if (this.colOpts.multi != null && !this.colOpts.multi) {
        if (items.length > 1) {
          return this.$msgbox('只允许选一个。')
        }
      }
      this.content = items.map(item => item[this.colOpts.spreadsheet.field || this.ss_opts.columns[0].label]).join(';')
      return this.onChange()
    },
    beforeShow: function() {
      if (this.colOpts.beforeShow) {
        return this.colOpts.beforeShow(this.rowObj)
      }
    },
    // loadMultiple: ->
    //   reverse = @colOpts.options.map (op) =>
    //   .join(@colOpts.separator)
    //   if @content
    //     console.log @content
    //     mult_arr = @content.split(@colOpts.separator)
    //     console.log mult_arr
    //     if mult_arr.length > 0
    //       @mult = mult_arr
    //       console.log @mult
    multipleSelect: function() {
      this.content = this.mult
        .map(item => this.colOpts.options[item])
        .sort()
        .join(this.colOpts.separator)
      return this.onChange()
    },
    blur: function() {
      return this.cellblur()
    },
    save: function() {
      if (!this.opts.tableName || !this.rowObj._id) {
        return
      }
      if (this.content === this.contentSaved) {
        return
      }
      // console.log 'content', @content
      return this.$nextTick(() => {
        let content, doSave, label
        if (this.opts.update) {
          return this.opts.update(this.rowObj, this.label, this.content)
        }
        if (this.content == null) {
          this.content = ''
        }
        content = this.content // 保存当前值
        label = this.label
        this.rowObj[label] = this.content
        doSave = _.debounce(() => {
          let ref
          return app.api
            .update({
              tableName: this.opts.tableName,
              _id: this.rowObj._id,
              data: {
                [`${label}`]: content,
                [`meta.${label}`]: {
                  lastModifiedTimeStamp: Date.now(),
                  lastModifiedBy: (ref = app.user) != null ? ref.account : void 0,
                },
              },
            })
            .then(() => {
              this.contentSaved = content
              return this.$emit('saved')
            })
        }, 200)
        return doSave()
        // 检查是否与服务器数据有冲突，开关默认不开启
        if (this.colOpts.avoidConflict) {
          return app.api
            .findOne({
              tableName: this.opts.tableName,
              _id: this.rowObj._id,
              fields: {
                [`${label}`]: 1,
              },
            })
            .then(res => {
              if (res[label] && res[label] !== this.contentSaved && content.indexOf(res[label]) === -1) {
                // console.log res, label, res[label], @contentSaved
                this.content = res[label]
                this.contentSaved = this.content
                this.render()
                return this.$msgbox(
                  `服务器数据发生变动! 当前修改保存失败。单元格内容更新为服务器内容：${
                    res[label]
                  }。当前修改内容：${content} (可用于复制粘贴)`,
                )
              } else {
                return doSave()
              }
            })
        } else {
          return doSave()
        }
      })
    },
    saveHTML: function() {
      if (!this.opts.tableName || !this.rowObj._id) {
        return
      }
      if (this.fake) {
        return
      }
      if (!this.opts.recycle) {
        return
      }
      if (this.colOpts.cache === 'disabled') {
        return
      }
      if (!this.$refs.fakeComp) {
        return
      }
      this.$refs.fakeComp.content = this.content
      this.$refs.fakeComp.render()
      return this.$nextTick(() => {
        let base, html, label, ref
        label = this.label
        if (!this.$refs.fake) {
          return
        }
        html = this.$refs.fake.innerHTML
        if (((ref = this.rowObj.html) != null ? ref[label] : void 0) === html) {
          return
        }
        // return
        // 清空该单元格缓存
        if ((base = this.rowObj).html == null) {
          base.html = {}
        }
        this.rowObj.html[label] = ''
        return app.api.update({
          tableName: this.opts.tableName,
          _id: this.rowObj._id,
          data: {
            [`html.${label}`]: html,
          },
        })
      })
    },
    html: function() {
      return this.rowObj[this.label]
    },
    update: function(content1) {
      let label, p
      this.content = content1
      this.render()
      if (this.content instanceof Date) {
        if (this.colOpts.type === 'datetime') {
          this.content = dateFormat(this.content, 'yyyy-mm-dd HH:MM:ss')
        } else if (this.colOpts.type === 'month') {
          this.content = dateFormat(this.content, 'yyyy-mm')
        } else {
          this.content = dateFormat(this.content, 'yyyy-mm-dd')
        }
      }
      label = this.label
      if (label && (this.rowObj[label] !== this.content || this.html() == null)) {
        if (typeof this.colOpts.beforeSaved === 'function') {
          p = this.colOpts.beforeSaved(this.rowObj, this.content)
        } else {
          p = Promise.resolve()
        }
        return p.then(() => this.save())
      }
    },
    cellblur: function() {
      return (this.editing = false)
    },
    render: function(content) {
      if (content) {
        this.content = content
      }
      if (typeof this.colOpts.background === 'function') {
        this.nowColor = this.colOpts.background(this.rowObj)
      } else if (this.inputType === 'color') {
        this.nowColor = this.colOpts.options[this.content] || 'transparent'
      } else {
        this.nowColor = 'transparent'
      }
      if (typeof this.content === 'object') {
        this.processedContent = JSON.stringify(this.content)
      } else if (typeof this.colOpts.display === 'function') {
        this.processedContent = this.colOpts.display(this.rowObj)
      } else if (this.inputType === 'textarea') {
        this.processedContent = this.encode(this.content)
      } else if (this.content && this.colOpts.cutContent) {
        this.processedContent = this.content.split('-')[0]
      } else if (this.content && this.colOpts.asterisk) {
        this.processedContent = `${this.content.substr(0, 3)}********`
      } else {
        this.processedContent = this.content
      }
      if (this.processedContent == null) {
        this.processedContent = ' '
      }
      if (!this.colOpts.hideTitle) {
        this.title = this.processedContent
      }
      if (this.mode === 'body') {
        return this.saveHTML()
      }
    },
    addRemark: function() {
      let arr_in, arr_out, extra, today, uname
      uname = app.user['姓名']
      today = dateFormat(new Date(), 'yyyy-mm-dd')
      if (this.remark) {
        extra = ''
        if (this.colOpts.addExtra) {
          arr_out = this.colOpts.addExtra.split('：')
          if (arr_out.length > 1) {
            arr_in = arr_out[1].split('-')
            extra = ` [${arr_in[0]}]`
          }
        }
        this.update(`${uname} [${today}]${extra} ${this.remark}; ${this.content}`)
        this.emitChange()
        this.remark = ''
        if (typeof this.colOpts.addInput === 'function') {
          return this.colOpts.addInput(this.rowObj)
        }
      }
    },
    findChild: function() {
      let field
      this.colOpts.options = {}
      this.showCascade = false
      field = this.rowObj[this.colOpts.field]
      if (!field) {
        return false
      }
      return app.api
        .find({
          tableName: this.colOpts.tableName,
          query: {
            [`${this.colOpts.childQuery}`]: field,
          },
        })
        .then(res => {
          let opt_arr, opt_obj, options
          // console.log res
          if (res) {
            options = res[0][this.colOpts.childFind]
            if (options) {
              opt_arr = options.split(';')
              opt_obj = {}
              opt_arr.map((opt, k) => {
                if (this.colOpts.saveKeyOrVal === 'val') {
                  return (opt_obj[`${opt}`] = opt)
                } else {
                  return (opt_obj[`${opt}`] = `(${k + 1})`)
                }
              })
              this.colOpts.options = opt_obj
              return (this.showCascade = true)
            }
          }
        })
    },
    openMenu: function(e) {},
  },
  // @$parent.openMenu e, @
  mounted: function() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    let k, placeholder, ref, ref1, ref2, v
    placeholder = null
    ref = this.placeholder
    for (k in ref) {
      v = ref[k]
      if ((ref1 = v.tagName) === 'DIV' || ref1 === 'PRE') {
        placeholder = v
      }
    }
    placeholder && this.$el.insertBefore(placeholder, this.$el.childNodes[0])
    if (this.shownColumns) {
      this.colOpts = this.shownColumns[this.col]
    } else {
      this.colOpts = this.opts.columns[this.col]
    }
    this.label = this.colOpts.label
    this.inputType = this.colOpts.type || 'text'
    this.isSpecialType = specialTypes[this.inputType]
    this.contentSaved = this.content = this.rowObj[this.label] || ''
    this.editable = this.opts.editable
    if (
      (!app.user.角色 || !app.user.角色.includes('管理员')) &&
      this.rowObj.permissions &&
      (this.rowObj.permissions[`${app.user.account}`] === '读取' ||
        (!this.rowObj.permissions[`${app.user.account}`] && this.rowObj.permissions['所有人'] === '读取'))
    ) {
      this.editable = false
    }
    if (this.inputType === 'link') {
      this.editable = true
    }
    if (this.inputType === 'spreadsheet') {
      this.ss_opts = JSON.parse(JSON.stringify(this.colOpts.spreadsheet.opts))
      this.ss_opts.loaded = data => {
        let label, labels
        labels = this.content.split(';')
        label = this.ss_opts.columns[0].label
        return (data = data.map(d => {
          let ref3
          if (((ref3 = d[label]), indexOf.call(labels, ref3) >= 0)) {
            d.checked = true
          }
          return d
        }))
      }
    }
    this.render()
    this.ready = true
    // 右键菜单
    // @$el.addEventListener 'contextmenu', (ev) =>
    //   ev.preventDefault()
    //   ev.stopPropagation()
    //   @showMenu = true
    //   @$nextTick =>
    //     @$refs.po.show()
    // @$refs.menu.style.left = ev.offsetX+"px"
    // @$refs.menu.style.top = ev.offsetY+"px"
    return this.$nextTick(() => {
      if (this.mode === 'form') {
        this.setOnblurEvent()
      }
      placeholder && this.$el.removeChild(placeholder)
      return this.$emit('mounted', this)
    })
  },
})
</script>
